import { defineStore } from 'pinia';

const useServerData = defineStore('serverData', {});

export default useServerData;
